import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { RsvpAnalyticsActionTypes } from './action-types';

export interface ITriggeredSocialShareAnalyticsAction {
  socialShareType: 'rsvpForm';
  socialShareMethod: keyof NonNullable<ISupplier['social']>;
}

export const triggeredSocialShareAnalytics = (
  payload: Omit<ITriggeredSocialShareAnalyticsAction, 'socialShareType'>,
) => ({
  type: RsvpAnalyticsActionTypes.TRIGGERED_SOCIAL_SHARE,
  payload: {
    socialShareType: 'rsvpForm',
    ...payload,
  },
});

// FULL TYPES BASED ON THE RSVP ANALYTICS DOCS

export interface IInteractedWithRsvpsActionPayload {
  action: 'added' | 'edited' | 'deleted';
  section: 'question' | 'deadline';
  type: 'popular' | 'custom' | 'date';
  question: string;
  answerType: 'yesNo' | 'selection' | 'longText';
  selectionList: string[];
  events: 'allEvents' | 'selectEvents';
  eventsList: string[];
  rsvpDeadline: string;
  category: string;
}

export const interactedWithRsvpsAnalyticsAction = (payload: IInteractedWithRsvpsActionPayload) => ({
  type: RsvpAnalyticsActionTypes.INTERACTED_WITH_RSVPS,
  payload,
});

// NARROWED DOWN TYPES BASED ON THE SPECS OF EACH SPECIFIC SCENARIO

interface IInteractedWithRsvpsDeadline {
  action: 'edited' | 'added' | 'deleted';
  rsvpDeadline: string;
}

interface IRsvpQuestionBase {
  type: 'custom' | 'popular';
  question: string;
  events: 'allEvents' | 'selectEvents';
  eventsList: string[];
}

interface IAddedOrEditedRsvpQuestionBase extends IRsvpQuestionBase {
  action: 'edited' | 'added';
}

interface IAddedOrEditedRsvpQuestionList extends IAddedOrEditedRsvpQuestionBase {
  answerType: 'selection';
  selectionList: string[];
}

interface IAddedOrEditedRsvpQuestionNonlist extends IAddedOrEditedRsvpQuestionBase {
  answerType: 'yesNo' | 'longText';
}

interface IDeletedRsvpQuestionBase extends IRsvpQuestionBase {}

interface IDeletedRsvpQuestionList extends IDeletedRsvpQuestionBase {
  answerType: 'selection';
  selectionList: string[];
}

interface IDeletedRsvpQuestionNonlist extends IDeletedRsvpQuestionBase {
  answerType: 'yesNo' | 'longText';
}

export const interactedWithRsvpsDeadlineAnalytics = (payload: IInteractedWithRsvpsDeadline) => ({
  type: RsvpAnalyticsActionTypes.INTERACTED_WITH_RSVPS,
  payload: {
    ...payload,
    section: 'deadline',
    type: 'date',
    category: 'guestManagement',
  },
});

export const deletedRsvpQuestionAnalytics = (
  payload: IDeletedRsvpQuestionList | IDeletedRsvpQuestionNonlist,
) => ({
  type: RsvpAnalyticsActionTypes.INTERACTED_WITH_RSVPS,
  payload: {
    ...payload,
    action: 'deleted',
    section: 'question',
    category: 'guestManagement',
  },
});

export const addedOrEditedRsvpQuestionAnalytics = (
  payload: IAddedOrEditedRsvpQuestionList | IAddedOrEditedRsvpQuestionNonlist,
) => ({
  type: RsvpAnalyticsActionTypes.INTERACTED_WITH_RSVPS,
  payload: {
    ...payload,
    section: 'question',
    category: 'guestManagement',
  },
});
